import { Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Action, ConfirmDialogConfig, CrudConfirmDialogComponent, CrudDeleteDialogComponent, CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { FIREARM_POOL_TYPE, FIREARM_TYPE, FirearmPool } from 'assets-model';
import { openJustfoneDataTransferDialog } from '../../datatransfer/dialog/justfone-data-transfer-dialog.component';
import { FirearmPoolService } from 'assets-service';


@Component({
  selector: 'app-firearm-pool-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class FirearmPoolEditorComponent extends CrudEditComponent<FirearmPool, number> implements OnInit {

  constructor(
    protected firearmPoolService: FirearmPoolService,
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();
    this.actions = [];
    var self = this;


    this.actions.push(<Action>{
      title: 'Firearm',
      get enabled(): boolean {
        const hasEditPermission = self.userStorage.currentUserHasAnyAuthority(FIREARM_TYPE.editAuthorities);
        const hasViewPermission = self.userStorage.currentUserHasAnyAuthority(FIREARM_TYPE.viewAuthorities);
        return hasEditPermission || hasViewPermission;
      },
      color: true,
      get available(): boolean {
        return self.item?.firearm?.assetId != null && !self.createMode;
      },
      getRoute() {
        return self.getFirearmRoute();
      },
      getQueryParams() {
        return self.backRouteQueryParams();
      }
    });
    this.actions.push(<Action>{
      title: 'Justfone Debug',
      get enabled(): boolean { return !self.unsavedChanges() },
      color: "primary",
      get available(): boolean {
        return self.currentUserHasAnyAuthority("IS_SUPERUSER");
      },
      doAction() {
        openJustfoneDataTransferDialog(self.dialog, 'FirearmPool', self.item.firearmAssetId);
      }
    });
    this.actions.push(<Action>{
      title: 'Delete Pool',
      get enabled(): boolean { return !self.unsavedChanges() },
      color: "warn",
      get available(): boolean {
        return !self.readOnly && !self.createMode && self.currentUserHasAnyAuthority(FIREARM_POOL_TYPE.deleteAuthorities);
      },
      doAction() {
        self.deletePool();
      }
    });
  }

  deletePool() {
    this.openSimpleConfirmationDialog("Are you sure you want to delete this pool?", "Delete Firearm Pool", "Delete").afterClosed().subscribe(() => {
      this.firearmPoolService.delete(this.item.firearmAssetId).subscribe(
        () => {
          this.snackbar.open('Firearm Pool deleted', 'OK', { duration: 3000 });
          this.navigate(this.getFirearmRoute(), this.backRouteQueryParams());
        }
      );
    });
  }

  getFirearmRoute() {
    const hasEditPermission = this.userStorage.currentUserHasAnyAuthority(FIREARM_TYPE.editAuthorities);
    const useEditRoute = hasEditPermission && !this.readOnly;
    const routeBase = useEditRoute ? FIREARM_TYPE.editRouteBase : FIREARM_TYPE.viewRouteBase;
    return [...routeBase, this.item?.firearm?.assetId]
  }

}






